import { render, staticRenderFns } from "./session-results.vue?vue&type=template&id=85f4642e&"
import script from "./session-results.vue?vue&type=script&lang=js&"
export * from "./session-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports